import axios from 'axios'
import { useMutation } from 'react-query'
import { useSelector } from 'react-redux'
import { useAuth0 } from '../../contexts/auth0-context'

type UseProcessPDFWithAIMutationProps = {
    onSuccess?: () => void
    onError?: (error: unknown) => void
}

type ProcessPDFVariables = {
    file: File
}

export const useProcessPDFWithAIMutation = ({ onSuccess, onError }: UseProcessPDFWithAIMutationProps = {}) => {
    const { isAuthenticated, getTokenSilently } = useAuth0()

    // @ts-expect-error store is not typed properly
    const orgId = useSelector((state) => state.strategy?.organizationId)

    const processPDF = async ({ file }: ProcessPDFVariables) => {
        if (!isAuthenticated) throw new Error('User must be authenticated to process a PDF')

        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

        const formData = new FormData()
        formData.append('pdfFile', file)
        console.log(file.name)
        const response = await axios.post('/api/summary/ai/' + orgId, formData, {
            headers: { Authorization: `Bearer ${token}` },
        })
        return response.data.message || {}
    }

    return useMutation(processPDF, {
        onSuccess: () => onSuccess?.(),
        onError: (error) => {
            console.error('Error processing PDF with AI:', error)
            onError?.(error)
        },
    })
}
